import {
  LEGACY_PROTOCOL_ITEM_COMMENT_PREFIX,
  PROTOCOL_ITEM_COMMENT_PREFIX,
  PROTOCOL_SECTION_COMMENT_PREFIX,
} from 'shared/domain/protocolAnswer/formKeys';

export type InspectionHeaderField =
  | 'inspectionDate'
  | 'workTypes'
  | 'sites'
  | 'levels'
  | 'controlledParty'
  | 'contracts'
  | 'comment';

const INSPECTION_HEADER_FIELDS = new Set<string>([
  'inspectionDate',
  'workTypes',
  'sites',
  'levels',
  'controlledParty',
  'contracts',
  'comment',
]);

export type ProtocolAtomicFormKey =
  | {
      kind: 'protocolItemComment';
      checklistItemId: string;
    }
  | {
      kind: 'protocolSectionComment';
      sectionId: string;
    };

/**
 * Unified type for all atomic form keys routed via persistField.
 * Protocol answers use typed saveProtocolAnswer — not parsed here.
 */
export type AtomicFormKey =
  | { kind: 'inspectionHeader'; field: InspectionHeaderField }
  | ProtocolAtomicFormKey;

export function parseProtocolAtomicFormKey(
  formKey: string
): ProtocolAtomicFormKey | null {
  if (formKey.startsWith(`${PROTOCOL_SECTION_COMMENT_PREFIX}-`)) {
    const sectionId = formKey.slice(`${PROTOCOL_SECTION_COMMENT_PREFIX}-`.length);
    return sectionId ? { kind: 'protocolSectionComment', sectionId } : null;
  }

  if (formKey.startsWith(`${PROTOCOL_ITEM_COMMENT_PREFIX}-`)) {
    const checklistItemId = formKey.slice(`${PROTOCOL_ITEM_COMMENT_PREFIX}-`.length);
    return checklistItemId
      ? { kind: 'protocolItemComment', checklistItemId }
      : null;
  }

  if (formKey.startsWith(`${LEGACY_PROTOCOL_ITEM_COMMENT_PREFIX}-`)) {
    const checklistItemId = formKey.slice(
      `${LEGACY_PROTOCOL_ITEM_COMMENT_PREFIX}-`.length
    );
    return checklistItemId
      ? { kind: 'protocolItemComment', checklistItemId }
      : null;
  }

  return null;
}

/**
 * Unified parser for atomic form keys handled by persistField (header + comments).
 */
export function parseAtomicFormKey(formKey: string): AtomicFormKey | null {
  if (INSPECTION_HEADER_FIELDS.has(formKey)) {
    return { kind: 'inspectionHeader', field: formKey as InspectionHeaderField };
  }

  return parseProtocolAtomicFormKey(formKey);
}
